import { buildQuery, buildVoidQuery } from '@/utils/react-query'

import {
  processings,
  processingsMetrics,
  processing,
  processingCollections,
  processingCollectionsMetrics,
  processingCollectionsFilters,
  exportProcessingCollections,
  processingSchools,
  processingSchoolsMetrics,
  processingSchoolsFilters,
  exportProcessingSchools,
  exportTechnicalAssignment,
} from './services'
import type {
  ProcessingsPayload,
  ProcessingsResponse,
  ProcessingsMetricsResponse,
  ProcessingPayload,
  ProcessingResponse,
  ProcessingCollectionsPayload,
  ProcessingCollectionsResponse,
  ProcessingCollectionsMetricsPayload,
  ProcessingCollectionsMetricsResponse,
  ProcessingCollectionsFiltersPayload,
  ProcessingCollectionsFiltersResponse,
  ExportProcessingCollectionsPayload,
  ExportProcessingCollectionsResponse,
  ProcessingSchoolsPayload,
  ProcessingSchoolsResponse,
  ProcessingSchoolsMetricsPayload,
  ProcessingSchoolsMetricsResponse,
  ProcessingSchoolsFiltersPayload,
  ProcessingSchoolsFiltersResponse,
  ExportProcessingSchoolsPayload,
  ExportProcessingSchoolsResponse,
  ExportTechnicalAssignmentPayload,
  ExportTechnicalAssignmentResponse,
} from './types'

export const useProcessings = buildQuery<
  ProcessingsResponse,
  ProcessingsPayload
>('processings', processings)

export const useProcessingsMetrics = buildVoidQuery<ProcessingsMetricsResponse>(
  'processings-metrics',
  processingsMetrics
)

export const useProcessing = buildQuery<ProcessingResponse, ProcessingPayload>(
  'processing',
  processing
)

export const useProcessingCollections = buildQuery<
  ProcessingCollectionsResponse,
  ProcessingCollectionsPayload
>('processing-collections', processingCollections)

export const useProcessingCollectionsMetrics = buildQuery<
  ProcessingCollectionsMetricsResponse,
  ProcessingCollectionsMetricsPayload
>('processing-collections-metrics', processingCollectionsMetrics)

export const useProcessingCollectionsFilters = buildQuery<
  ProcessingCollectionsFiltersResponse,
  ProcessingCollectionsFiltersPayload
>('processing-collections-filters', processingCollectionsFilters)

export const useExportProcessingCollections = buildQuery<
  ExportProcessingCollectionsResponse,
  ExportProcessingCollectionsPayload
>('export-processing-collections', exportProcessingCollections)

export const useProcessingSchools = buildQuery<
  ProcessingSchoolsResponse,
  ProcessingSchoolsPayload
>('processing-schools', processingSchools)

export const useProcessingSchoolsMetrics = buildQuery<
  ProcessingSchoolsMetricsResponse,
  ProcessingSchoolsMetricsPayload
>('processing-school-metrics', processingSchoolsMetrics)

export const useProcessingSchoolsFilters = buildQuery<
  ProcessingSchoolsFiltersResponse,
  ProcessingSchoolsFiltersPayload
>('processing-schools-filters', processingSchoolsFilters)

export const useExportProcessingSchools = buildQuery<
  ExportProcessingSchoolsResponse,
  ExportProcessingSchoolsPayload
>('export-processing-schools', exportProcessingSchools)

export const useExportTechnicalAssignment = buildQuery<
  ExportTechnicalAssignmentResponse,
  ExportTechnicalAssignmentPayload
>('export-technical-assignment', exportTechnicalAssignment)
